import { Pipe, PipeTransform } from '@angular/core';

interface FitDisplayItem {
  ExpireDate?: Date | string | number | null;
  approvalRequest?: unknown;
}

@Pipe({
  name: 'fit',
  standalone: false,
})
export class FitPipe implements PipeTransform {
  transform(item: FitDisplayItem | null | undefined, show = false) {
    if (new Date(item?.ExpireDate) < new Date()) {
      return `${show ? '(' : ''}expired${show ? ')' : ''}`;
    } else if (item?.approvalRequest) {
      return `${show ? '(' : ''}pending${show ? ')' : ''}`;
    }
    return '';
  }
}
